import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class LoaderService {
  disable = false;

  private readonly displayDelayMs = 250;
  private displayTimer: ReturnType<typeof setTimeout> | undefined;
  private activeRequestCount = 0;
  private globalLoaderSuppressionCount = 0;

  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  public isLoading: Observable<boolean> = this.isLoadingSubject.asObservable();

  beginRequest() {
    this.activeRequestCount++;

    if (this.activeRequestCount === 1) {
      this.show();
    }
  }

  endRequest() {
    this.activeRequestCount = Math.max(0, this.activeRequestCount - 1);

    if (this.activeRequestCount === 0) {
      this.hide();
    }
  }

  suppressGlobalLoader() {
    this.globalLoaderSuppressionCount++;
    this.hide();
  }

  resumeGlobalLoader() {
    const wasSuppressed = this.isGlobalLoaderSuppressed;
    this.globalLoaderSuppressionCount = Math.max(
      0,
      this.globalLoaderSuppressionCount - 1
    );

    // A request that began before a locally-owned page was displayed can still
    // be in flight when that page is destroyed. Restore its global feedback
    // once the final suppression scope has ended.
    if (
      wasSuppressed &&
      !this.isGlobalLoaderSuppressed &&
      this.activeRequestCount > 0
    ) {
      this.show();
    }
  }

  get isGlobalLoaderSuppressed(): boolean {
    return this.globalLoaderSuppressionCount > 0;
  }

  // Legacy components can still explicitly show or hide the global loader for
  // work that is not represented by a single HTTP request.
  show() {
    if (this.isGlobalLoaderSuppressed || this.displayTimer) {
      return;
    }

    this.displayTimer = setTimeout(() => {
      this.displayTimer = undefined;
      this.isLoadingSubject.next(true);
    }, this.displayDelayMs);
  }

  hide() {
    if (this.displayTimer) {
      clearTimeout(this.displayTimer);
      this.displayTimer = undefined;
    }

    this.isLoadingSubject.next(false);
  }
}
